import React from 'react';
import './SubmitButton.css';

const submitButton = (props) => (
    <p className="AddButtonSubmit" onClick={props.click}>Submit</p>

)

export default submitButton;